import { render, staticRenderFns } from "./MessageUI.html?vue&type=template&id=317e1d23&scoped=true&external"
import script from "./MessageUI.js?vue&type=script&lang=js&external"
export * from "./MessageUI.js?vue&type=script&lang=js&external"
import style0 from "./MessageUI.scss?vue&type=style&index=0&id=317e1d23&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317e1d23",
  null
  
)

export default component.exports